import moment from 'moment'

moment.locale('pt-br')

export function toCurrencyNumber(value) {
  if (value === null || value === undefined || value === '') {
    return 0
  }

  if (typeof value === 'number') {
    return value
  }

  const cleaned = String(value)
    .replace(/R\$\s?/g, '')
    .replace(/\./g, '')
    .replace(',', '.')
    .trim()

  const parsed = Number(cleaned)
  return Number.isFinite(parsed) ? parsed : 0
}

export function formatCurrency(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(toCurrencyNumber(value))
}

export function formatDate(value) {
  if (!value) {
    return '--'
  }

  const parsed = moment.utc(value)
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : value
}

export function getStatus(item) {
  if (item && item.pago) {
    return 'paid'
  }

  const due = moment.utc(item && item.data_vencimento)
  const today = moment.utc().startOf('day')

  if (!due.isValid()) {
    return 'unknown'
  }

  const diff = due.diff(today, 'days')

  if (diff < 0) {
    return 'overdue'
  }

  if (diff === 0) {
    return 'today'
  }

  if (diff <= 7) {
    return 'upcoming'
  }

  return 'open'
}

export function statusLabel(status, type) {
  const payable = {
    paid: 'Pago',
    overdue: 'Vencido',
    today: 'Vence hoje',
    upcoming: 'Vence em breve',
    open: 'Em aberto',
    unknown: 'Sem vencimento',
  }

  const receivable = {
    paid: 'Recebido',
    overdue: 'Atrasado',
    today: 'Receber hoje',
    upcoming: 'Receber em breve',
    open: 'Em aberto',
    unknown: 'Sem vencimento',
  }

  return (type === 'RECEBER' ? receivable : payable)[status] || 'Em aberto'
}

export function normalizeFinanceItem(item, type) {
  const status = getStatus(item)

  return {
    ...item,
    tipo_operacao: type,
    valorNumerico: toCurrencyNumber(item.valor_final || item.valor),
    status,
    statusLabel: statusLabel(status, type),
    descricaoConta:
      item.descricao ||
      (item.categoria && item.categoria.descricao) ||
      (item.tipoConta && item.tipoConta.tipo) ||
      'Sem descricao',
  }
}

export function buildDashboardMetrics(payables = [], receivables = []) {
  const openPayables = payables.filter((item) => !item.pago)
  const openReceivables = receivables.filter((item) => !item.pago)

  return {
    totalPagar: openPayables.reduce(
      (total, item) => total + toCurrencyNumber(item.valor_final || item.valor),
      0
    ),
    totalReceber: openReceivables.reduce(
      (total, item) => total + toCurrencyNumber(item.valor_final || item.valor),
      0
    ),
    vencidasPagar: openPayables.filter((item) => getStatus(item) === 'overdue')
      .length,
    vencidasReceber: openReceivables.filter(
      (item) => getStatus(item) === 'overdue'
    ).length,
    vencendoHoje: [...openPayables, ...openReceivables].filter(
      (item) => getStatus(item) === 'today'
    ).length,
  }
}

export function buildAgendaItems(payables = [], receivables = []) {
  return [...payables.map((item) => normalizeFinanceItem(item, 'PAGAR')), ...receivables.map((item) => normalizeFinanceItem(item, 'RECEBER'))]
    .filter((item) => item.status !== 'paid')
    .sort((a, b) => {
      const timeA = moment.utc(a.data_vencimento).valueOf()
      const timeB = moment.utc(b.data_vencimento).valueOf()
      return timeA - timeB
    })
}
